import { render, staticRenderFns } from "./bookmakersettings.vue?vue&type=template&id=5bc12d47&scoped=true"
import script from "./bookmakersettings.vue?vue&type=script&lang=js"
export * from "./bookmakersettings.vue?vue&type=script&lang=js"
import style0 from "./bookmakersettings.vue?vue&type=style&index=0&id=5bc12d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc12d47",
  null
  
)

export default component.exports